import {useState} from 'react';
import {useControllers} from '../../../../../../../common/helpers/react/hooks/useControllers';
import {AddRemoveInfo} from './AddRemoveInfo';
import {SearchType} from '../../../../../../../common/model/types/assignees/SearchType';
import {useOnce} from '../../../../../../../common/helpers/react/hooks/useOnce';
import AssigneesTable from '../../../assignees/AssigneesTable';
import {cssClasses} from '../../../../../../../common/helpers/browser/cssClasses';
import AssigneesSearch from '../../../assignees/AssigneesSearch';
import AssigneesToolbar from '../../../assignees/AssigneesToolbar';

export type GroupWizardAddAssigneesModalProps = {
    checkedRows?: string[],
    groupId: number,
    addRemoveInfo: AddRemoveInfo
}

export default function GroupWizardAddAssigneesModal(props: GroupWizardAddAssigneesModalProps) {
    const [checkedRows, setCheckedRows] = useState<string[]>(props.checkedRows ?? []);

    const dialog = useControllers().dialog;
    const modal = dialog.getCurrentModal$().useState() ?? {};

    const groups = useControllers().groups;

    modal.data = {
        add: checkedRows
    };

    useOnce(() => groups.searchForPossibleAssignees()).andWeAreDone();

    return (
        <>
            <AssigneesSearch
                addRemoveInfo={props.addRemoveInfo}
                groupId={props.groupId}
                initialSearchType={SearchType.PCC}
            />
            <AssigneesToolbar
                addRemoveInfo={props.addRemoveInfo}
                groupId={props.groupId}
                setCheckedRows={setCheckedRows}
                checkedRows={checkedRows}
            />
            <AssigneesTable
                addRemoveInfo={props.addRemoveInfo}
                groupId={props.groupId}
                checkedRows={checkedRows}
                setCheckedRows={setCheckedRows}
                className={cssClasses(
                    'qa-add-assignees-table'
                )}
            />
        </>
    );
}